export default __webpack_public_path__ + "static/media/link-solid.89385222.svg";